// Design 038: background a publication logo sits on, so publishers can suit their logo
// to the dark UI. light = white tile (dark logos), transparent = none (light logos made
// for dark themes), dark = subtle dark panel. Unknown/missing => light (the safe default).
export function logoBgColor(bg) {
  if (bg === 'transparent') return 'transparent';
  if (bg === 'dark') return '#10101c';
  return '#ffffff'; // light (default)
}

export const LOGO_BG_OPTIONS = [
  { value: 'light', label: 'Light' },
  { value: 'transparent', label: 'Transparent' },
  { value: 'dark', label: 'Dark' },
];
